import { ParamListBase } from '@react-navigation/native';

const modals = {} as RegisteredModals;
const bottomSheets = {} as RegisteredBottomSheets;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const navigationHandlers = {} as RegisteredNavigationHandlers<any>;

export function registerModals<K extends keyof RegisteredModals>(
  namespace: K,
  newModals: RegisteredModals[K],
) {
  modals[namespace] = {
    ...modals[namespace],
    ...newModals,
  };
}

export function getModals() {
  return modals;
}

export function registerBottomSheets<K extends keyof RegisteredBottomSheets>(
  namespace: K,
  newBottomSheets: RegisteredBottomSheets[K],
) {
  bottomSheets[namespace] = {
    ...bottomSheets[namespace],
    ...newBottomSheets,
  };
}

export function registerNavigationHandlers<
  T extends ParamListBase,
  K extends keyof T,
>(handlers: RegisteredNavigationHandlers<Pick<T, K>>) {
  for (const screen in handlers) {
    if (screen in navigationHandlers) {
      throw new Error(
        `Navigation handler for '${screen}' screen already exists`,
      );
    }

    navigationHandlers[screen] = handlers[screen];
  }
}

export function getBottomSheets() {
  return bottomSheets;
}

export function getNavigationHandlers() {
  return navigationHandlers;
}
